import React, { useContext, useState, useEffect } from "react"
import { PaginationButton } from "../../components"
import { useFetchApi } from "../../hooks"
import { useTranslation } from "react-i18next"
import { LangContext } from "../../LangProvider"

function Transparency() {
  const { lang } = useContext(LangContext)
  const { t } = useTranslation()
  const [page, setPage] = useState(0)

  const limit = 3
  const [
    {
      data: { donations, totalPage },
      loading
    },
    doFetch
  ] = useFetchApi(`/donations?limit=${limit}&&page=${page}&&lang=${lang}`, {
    donations: [],
    totalPage: 0
  })

  const handlePagination = page => {
    setPage(page.selected)
    doFetch(`/donations?limit=${limit}&&page=${page.selected}&&lang=${lang}`)
  }

  useEffect(() => {
    doFetch(`/donations?limit=${limit}&&page=${page}&&lang=${lang}`)
  }, [lang])

  return (
    <div className="uk-margin-large-bottom bg-red uk-padding-small uk-padding-remove-horizontal">
      <h1 className="uk-margin-bottom uk-text-center font-white">
        {t("ourprogram.transparency")}
      </h1>
      <div className="uk-container">
        {loading ? (
          <div
            uk-spinner="ratio: 2.5"
            className="uk-text-center uk-align-middle uk-margin-bottom font-white"
          ></div>
        ) : donations.length ? (
          <table className="uk-table uk-table-small uk-table-divider uk-margin-bottom font-white">
            <thead>
              <tr>
                <th className="font-white">Donation Report</th>
                <th className="font-white">Document PDF</th>
              </tr>
            </thead>
            <tbody>
              {donations.map(doc => (
                <tr key={doc._id}>
                  <td>{doc.title}</td>
                  <td>
                    <a
                      href={doc.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="uk-link-reset"
                    >
                      <span uk-icon="icon: file-pdf"></span>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <h2 className="font-white uk-text-center">
            Sorry, we dont have report yet
          </h2>
        )}
        {donations.length ? (
          <PaginationButton
            totalPage={totalPage}
            handlePagination={handlePagination}
            linkColour="font-white"
          />
        ) : null}
      </div>
    </div>
  )
}

export default Transparency
